import classes from './LoginPage.module.scss'
import { Form } from 'react-bootstrap'
import { Button, ButtonTheme } from '../../../shared/ui/Button/Button'
import { Button as Btn } from '@mui/material'
import React, { useState } from 'react'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash'
import { loginActions } from '../model/slices/loginSlice'
import { loginService } from '../model/services/loginService'
import { useForm } from 'react-hook-form'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useNavigate } from 'react-router-dom'
import googleSVG from '../../../shared/assets/svgs/devicon_google.svg'
import Box from '@mui/material/Box'
import { RoutePath } from '../../../shared/config/routeConfig/routeConfig'

interface IFormInput {
	login: string
	password: string
}

export const LoginForm = () => {
	const {
		formState: { errors },
		handleSubmit,
		reset
	} = useForm<IFormInput>({ mode: 'onBlur' })
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	const login = useAppSelector((state) => state.loginState.login)
	const password = useAppSelector((state) => state.loginState.password)

	const [passwordShown, setPasswordShown] = useState(false)
	const handleMouseDown = () => setPasswordShown(true)
	const handleMouseUp = () => setPasswordShown(false)
	const eye = <FontAwesomeIcon icon={passwordShown ? faEye : faEyeSlash} />

	const handleLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(loginActions.setLogin(event.target.value))
	}

	const handlePasswordChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		dispatch(loginActions.setPassword(event.target.value))
	}

	const onSubmit = async () => {
		const result = await dispatch(loginService({ login, password }))

		if (result.meta.requestStatus === 'fulfilled') {
			navigate(RoutePath.login_mfa)
			reset()
		}
	}

	const handleSignInWithGoogle = () => {
		window.location.href = window.location.origin + `/api/login/google?returnUrl=${
			window.location.origin + RoutePath.auth_google
		}`
	}

	return (
		<Form
			onSubmit={handleSubmit(onSubmit)}
			className={classes['form-content']}
		>
			<h2 className="mb-4">Authentication</h2>
			<Form.Group
				className={classes['login-input']}
				controlId="login-input"
			>
				<Form.Label>Login</Form.Label>
				<Form.Control
					autoFocus
					type="text"
					value={login}
					placeholder="Login"
					isInvalid={!!errors?.login}
					onChange={handleLoginChange}
				/>
				{errors?.login && (
					<Form.Control.Feedback type="invalid">
						{errors?.login?.message ||
							'Login is invalid'}
					</Form.Control.Feedback>
				)}
			</Form.Group>
			<Form.Group
				className={classes['password-input-group']}
				controlId="password-input"
			>
				<Form.Label>Password</Form.Label>
				<Form.Control
					className={classes['password-input']}
					type={passwordShown ? 'text' : 'password'}
					value={password}
					placeholder="Password"
					isInvalid={!!errors?.password}
					onChange={handlePasswordChange}
				/>
				<span
					className={classes.eye}
					onMouseUp={handleMouseUp}
					onMouseDown={handleMouseDown}
				>
					{eye}
				</span>
				{errors?.password && (
					<Form.Control.Feedback type="invalid">
						{errors?.password?.message ||
							'Password is invalid'}
					</Form.Control.Feedback>
				)}
			</Form.Group>
			<Button
				type="submit"
				theme={ButtonTheme.APPLY}
				className="w-100"
			>
				Login
			</Button>
			<Box sx={{ textAlign: 'center', my: '0.25rem' }}>or</Box>
			<Btn
				variant="outlined"
				size="medium"
				sx={{ width: '100%', textTransform: 'none' }}
				onClick={handleSignInWithGoogle}
			>
				<img src={googleSVG} alt="Google logo" />
				<Box component="span" sx={{ ml: 2, color: '#000' }}>
					Sign in with Google
				</Box>
			</Btn>
		</Form>
	)
}